module.exports = __webpack_public_path__ + "img/btn-record.0942a4f3.png";